/**
 * Round a number to 2 decimal places
 * @param value - The number to round
 * @returns The rounded number
 */
export const roundToDecimal = (value: number): number => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

/**
 * Round a number to specified decimal places
 * @param value - The number to round
 * @param decimals - Number of decimal places (default: 2)
 * @returns The rounded number
 */
export const roundToDecimals = (value: number, decimals = 2): number => {
  const factor = Math.pow(10, decimals);
  return Math.round((value + Number.EPSILON) * factor) / factor;
}; 